<script setup lang="ts">
import { ref, onMounted } from 'vue'
import {
  fetchNoticeReadAllNotice,
  fetchNoticeReadAllStation,
  fetchNoticeReadAllSystem,
  fetchStationNoticeList,
  fetchSystemNoticeList,
  fetchNoticeReadSingleStation,
  fetchNoticeReadSingleSystem,
  fetchNoticeReadSingleNotice
} from '@/api/projectCenter/user'
import { fetchHomeNoticeList } from '@/api/common'
import common from '@/utils/common'

const activeName = ref('notice')
const noticeList = ref([])
const stationList = ref([])
const systemList = ref([])
const dialogVisible = ref(false)
const dialogTitle = ref('')
const noticeText = ref('')
let emptyImg = ref('')
let icon1 = ref('')
let icon2 = ref('')
let icon3 = ref('')
let unread = ref(false)

// 区分美吉、桑格
const { VITE_APP_MJ_KF_ORIGIN, VITE_APP_SG_KF_ORIGIN } = import.meta.env

let kfOrigin = ref('')

if (common.getWebName() === 'mj' || common.getWebName() === 'local') {
  kfOrigin.value = VITE_APP_MJ_KF_ORIGIN
} else if (common.getWebName() === 'sg') {
  kfOrigin.value = VITE_APP_SG_KF_ORIGIN
}

emptyImg.value = `${kfOrigin.value}/static/img/common/header/empty_1.png`
icon1.value = `${kfOrigin.value}/static/img/common/header/notice.png`
icon2.value = `${kfOrigin.value}/static/img/common/header/maill.png`
icon3.value = `${kfOrigin.value}/static/img/common/header/msg.png`

// tabs切换
const handleClick = (key: number) => {
  console.log(key, typeof key)
  activeName.value = key.props.name
  if (key.props.name === 'notice') {
    getNoticeList()
  } else if (key.props.name === 'letter') {
    getStationNoticeList()
  } else if (key.props.name === 'system') {
    getSystemNoticeList()
  }
}

// 公告列表
const getNoticeList = () => {
  fetchHomeNoticeList({}).then((res: any) => {
    let { code, data } = res
    if (code === 0) {
      noticeList.value = data.data
      data.data.forEach((item: any) => {
        if (!item.is_read) {
          unread.value = true
        }
      })
    }
  })
}

// 站内信列表
const getStationNoticeList = () => {
  let params = {
    page: 1,
    page_size: 30,
    view_status: null
  }
  fetchStationNoticeList(params).then((res: any) => {
    let { code, data } = res
    if (code === 0) {
      stationList.value = data.lists
      data.lists.forEach((item: any) => {
        if (!item.view_status) {
          unread.value = true
        }
      })
    }
  })
}

// 系统通知列表
const getSystemNoticeList = () => {
  let params = {}
  fetchSystemNoticeList(params).then((res: any) => {
    let { code, data } = res
    if (code === 0) {
      systemList.value = data
      data.forEach((item: any) => {
        if (!item.view_status) {
          unread.value = true
        }
      })
    }
  })
}

// 消息详情
const onDetail = (item: any) => {
  dialogVisible.value = true

  console.log(item, 'item')
  if (activeName.value === 'notice') {
    dialogTitle.value = item.notice_title
    noticeText.value = item.notice_content
    onReadedSingle(item.notice_id)
  } else if (activeName.value === 'letter') {
    dialogTitle.value = item.title
    noticeText.value = item.content
    onReadedSingle(item.notice_id)
  } else if (activeName.value === 'system') {
    dialogTitle.value = item.title
    noticeText.value = item.content
    onReadedSingle(item.id)
  }
}

// 查看全部
const onLookAll = () => {
  if (activeName.value === 'notice') {
    window.location.href = `${kfOrigin.value}/web/ucenter/personal/message/index`
  } else if (activeName.value === 'letter') {
    window.location.href = `${kfOrigin.value}/web/ucenter/personal/message/station-index`
  }
}

// 全部标记已读
const onReadedAll = () => {
  if (activeName.value === 'notice') {
    fetchNoticeReadAllNotice({}).then((res: any) => {
      let { code, message } = res
      if (code === 0) {
        ElMessage({
          message: '操作成功',
          type: 'success'
        })
      } else {
        ElMessage({
          message,
          type: 'error'
        })
      }
    })
  } else if (activeName.value === 'letter') {
    fetchNoticeReadAllStation({}).then((res: any) => {
      let { code, message } = res
      if (code === 0) {
        ElMessage({
          message: '操作成功',
          type: 'success'
        })
      } else {
        ElMessage({
          message,
          type: 'error'
        })
      }
    })
  } else if (activeName.value === 'system') {
    fetchNoticeReadAllSystem({}).then((res: any) => {
      let { code, message } = res
      if (code === 0) {
        ElMessage({
          message: '操作成功',
          type: 'success'
        })
      } else {
        ElMessage({
          message,
          type: 'error'
        })
      }
    })
  }
}

// 单个标记已读
const onReadedSingle = (id) => {
  if (activeName.value === 'notice') {
    let params = { article_id: id }
    fetchNoticeReadSingleNotice(params).then((res: any) => {
      let { code, message } = res
      if (code === 0) {
        return
      } else {
        ElMessage({
          message,
          type: 'error'
        })
      }
    })
  } else if (activeName.value === 'letter') {
    let params = { notice_id: id }
    fetchNoticeReadSingleStation(params).then((res: any) => {
      let { code, message } = res
      if (code === 0) {
        return
      } else {
        ElMessage({
          message,
          type: 'error'
        })
      }
    })
  } else if (activeName.value === 'system') {
    let params = { id }
    fetchNoticeReadSingleSystem(params).then((res: any) => {
      let { code, message } = res
      if (code === 0) {
        return
      } else {
        ElMessage({
          message,
          type: 'error'
        })
      }
    })
  }
}

onMounted(() => {
  if (window.location.pathname !== '/project-center/download') {
    getNoticeList()
  }
  getStationNoticeList()
  getSystemNoticeList()
})
</script>

<template>
  <el-popover
    placement="bottom-end"
    :width="400"
    trigger="hover"
    popper-class="notice-popover"
  >
    <template #reference>
      <el-badge :is-dot="unread" class="pointer">消息</el-badge>
    </template>
    <template #default>
      <el-tabs
        v-model="activeName"
        class="notice-tabs"
        @tab-click="handleClick"
      >
        <el-tab-pane name="notice">
          <template #label>
            <span class="custom-tabs-label">
              <img class="label-icon" :src="icon1" />
              <span>公告</span>
            </span>
          </template>
          <ul class="notice-list" v-if="noticeList.length > 0">
            <li
              v-for="(item, index) in noticeList"
              :key="index"
              :class="['mj-theme-bg-hover', item.is_read ? 'readed' : '']"
              @click="onDetail(item)"
            >
              {{ item.notice_title }}
            </li>
          </ul>
          <el-empty
            v-else
            class="empty-notice"
            :image-size="100"
            :image="emptyImg"
            description="暂无信息"
          />
        </el-tab-pane>
        <el-tab-pane name="letter">
          <template #label>
            <span class="custom-tabs-label">
              <img class="label-icon" :src="icon2" />
              <span>站内信</span>
            </span>
          </template>
          <ul class="notice-list" v-if="stationList.length > 0">
            <li
              v-for="(item, index) in stationList"
              :key="index"
              :class="['mj-theme-bg-hover', item.view_status ? 'readed' : '']"
              @click="onDetail(item)"
            >
              {{ item.title }}
            </li>
          </ul>
          <el-empty
            v-else
            class="empty-notice"
            :image-size="100"
            :image="emptyImg"
            description="暂无信息"
          />
        </el-tab-pane>
        <el-tab-pane name="system">
          <template #label>
            <span class="custom-tabs-label">
              <img class="label-icon" :src="icon3" />
              <span>系统通知</span>
            </span>
          </template>
          <ul class="notice-list" v-if="systemList.length > 0">
            <li
              v-for="(item, index) in systemList"
              :key="index"
              :class="['mj-theme-bg-hover', item.view_status ? 'readed' : '']"
              @click="onDetail(item)"
            >
              {{ index + 1 }}. {{ item.title }}
            </li>
          </ul>
          <el-empty
            v-else
            class="empty-notice"
            :image-size="100"
            :image="emptyImg"
            description="暂无信息"
          />
        </el-tab-pane>
      </el-tabs>
      <div class="notice-tabs-footer flex justify-between items-center">
        <span class="readed" @click="onReadedAll">全部标记已读</span>
        <span
          class="link blue mj-theme-ft f16"
          @click="onLookAll"
          v-if="activeName === 'notice' || activeName === 'letter'"
          >查看全部</span
        >
      </div>
    </template>
  </el-popover>

  <!-- 消息详情（模态弹窗） -->
  <el-dialog
    draggable
    v-model="dialogVisible"
    align-center
    width="800"
    :title="dialogTitle"
    :before-close="() => (dialogVisible = false)"
    class="notice-dialog"
  >
    <p class="notice-text" v-html="noticeText"></p>
  </el-dialog>
</template>

<style lang="scss"></style>
